import React from 'react';

import css from './QuoteCard.module.css';
import { formatDateMed } from '../../../../../../../lib/date';
import EntityPill from '../../../../../../../components/EntityPill/EntityPill';
import BriefPill from '../../../../../../../components/BriefPill/BriefPill';
import QuoteBadge from '../../../../../QuoteBadge/QuoteBadge';
import AiBadge from '../../../../../AiBadge/AiBadge';
import useNavigation from '../../../../../../hooks/useNavigation';

function QuoteCard({ quote, showEvent = false }) {
  const { toggleEventDossier, params } = useNavigation();
  const onClickEvent = () => {
    params.delete('dossierEntityId');
    toggleEventDossier(quote.event.id);
  };

  return (
    <div>
      <div className={css.main} data-cy="quote-card">
        <QuoteBadge />
        <div className={css.quote} data-cy="quote-title">
          {`"${quote.quote}"`}
        </div>
        <div className={css.date} data-cy="quote-date">
          {formatDateMed(quote.date)}
        </div>
        <div className={css.entities} data-cy="quote-entities">
          <EntityPill
            id={quote.speaker.id}
            autoOpenDossier
            name={quote.speaker.name}
            image={quote.speaker.image}
            isConnected={quote.speaker.isConnected}
            inSubscription={quote.speaker.inSubscription}
            type={quote.speaker.type}
            size="small"
          />
        </div>
        <div className={css.briefs} data-cy="quote-briefs">
          {quote.industries.map((brief) => (
            <BriefPill key={brief.id} name={brief.name} tooltip="" />
          ))}
          {quote.countries.map((country) => (
            <BriefPill key={country.id} name={country.name} isGeography />
          ))}
        </div>
      </div>
      <div className={css.context} data-cy="quote-context">
        <div className={css.title}>
          Context
          <AiBadge />
        </div>
        {quote.context}
      </div>
      {showEvent && (
        <div className={css.event} data-cy="quote-event" onClick={onClickEvent}>
          {quote.event.title}
        </div>
      )}
    </div>
  );
}

export default QuoteCard;
